var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-checkbox-group',{on:{"change":_vm.handleCheckedCitiesChange},model:{value:(_vm.checkedCities),callback:function ($$v) {_vm.checkedCities=$$v},expression:"checkedCities"}},_vm._l((_vm.dataList),function(item){return _c('el-checkbox',{key:item.id,attrs:{"label":item.name}},[_vm._v(_vm._s(item.name))])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }